import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Field, ErrorMessage } from 'formik';
import StyledCheckbox from './styles';

const CheckboxField = ({ name, type, label, ...rest }) => (
	<StyledCheckbox>
		<Field
			name={name}
			as={FormControlLabel}
			label={label}
			{...rest}
			control={<Checkbox color="primary" />}
		/>
		<ErrorMessage name={label} component="div" />
	</StyledCheckbox>
);

export default CheckboxField;
